import { useQuery } from '@tanstack/react-query';

import { useStudioStore } from '~entities/studios/model/studio-store';

import { baseAPI } from '~shared/api/base-api';
import { QUERY_KEYS } from '~shared/api/query-keys';

import type { StudioPreflightCheckResponse } from '../model/preflight-check.types';

export const getStudioPreflightCheckAPI = async () => {
  try {
    const response = await baseAPI.get<StudioPreflightCheckResponse>(
      '/studios/preflight-check',
    );
    return response.data;
  } catch (error) {
    console.error('Failed to load studio preflight check', error);
    throw error;
  }
};

export const useGetStudioPreflightCheck = () => {
  const currentStudioId = useStudioStore((state) => state.currentStudioId);

  return useQuery({
    queryKey: QUERY_KEYS.STUDIO_PREFLIGHT_CHECK(currentStudioId),
    queryFn: () => getStudioPreflightCheckAPI(),
    enabled: Boolean(currentStudioId),
  });
};
